import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    Grid,
    MarkdownContent,
    Typography,
} from 'wanderu-components';

import EditorialCards from '../EditorialCards/EditorialCards';
import StationsList from '../StationsList/StationsList';

import styles from './BlurbSection.scss';

function BlurbSection(props) {
    const {
        namespace,
        subtitle,
        subtitleClass,
        images = [],
        maxImages,
        imageSubtitle = '',
        description,
        stationsSubtitle = '',
        stations = [],
    } = props;

    if (!subtitle && !description && !images.length && !stations.length) {
        return null;
    }

    return (
        <div>
            {!!subtitle && (
                <Typography
                    className={classNames(styles.subtitle, subtitleClass)}
                    component="h3"
                    variant="subtitle"
                >
                    {subtitle}
                </Typography>
            )}
            {!!images.length && (
                <Grid
                    className={styles.imageGrid}
                    rowSpacing={2}
                    autoRows
                >
                    {images.slice(0, maxImages).map((image) => (
                        <EditorialCards
                            imageObj={image}
                            key={image.src}
                            namespace={namespace}
                        />
                    ))}
                </Grid>
            )}
            {!!imageSubtitle && (
                <Typography
                    className={styles.imageSubtitle}
                    component="h4"
                    variant="h6"
                >
                    {imageSubtitle}
                </Typography>
            )}
            {!!description && (
                <Typography
                    className={styles.mainContentBody}
                    component={MarkdownContent}
                >
                    {description}
                </Typography>
            )}
            <StationsList
                stations={stations}
                stationsSubtitle={stationsSubtitle}
            />
        </div>
    );
}

BlurbSection.propTypes = {
    subtitle: PropTypes.string,
    subtitleClass: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.object),
    maxImages: PropTypes.number.isRequired,
    imageSubtitle: PropTypes.string,
    description: PropTypes.string,
    stationsSubtitle: PropTypes.string,
    stations: PropTypes.arrayOf(PropTypes.object),
};

export default BlurbSection;
